import installer from './defaults'
export * from '@bigin/components'
export * from '@bigin/constants'
export * from '@bigin/directives'
export * from '@bigin/hooks'
export * from '@bigin/tokens'
export { makeInstaller } from './make-installer'

export const install = installer.install
export const version = installer.version
export default installer

export { default as dayjs } from 'dayjs'
